export default __webpack_public_path__ + "static/media/mlbFantasyPWRSbg.92e278a7.png";